module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1@2-988d10232d32737940713e7059f3aac0.jpg";